import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class DeviceAccountRegisterSessionStorageService {
   private readonly deviceOrderingOptionsStorageKey = '__ndt-account-device-ordering-options';

   clearAccountAll(): void {
      localStorage.clear();
   }

   removeAccountDeviceOrderingOptions(): void {
      localStorage.removeItem(this.deviceOrderingOptionsStorageKey);
   }

   getAccountDeviceOrderingOptions() {
      const localData = localStorage.getItem(this.deviceOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setAccountDeviceOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.deviceOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
